// @flow
import React from 'react';
import type { SpacingBlock as SpacingBlockType } from 'message-parsing';

type SpacingBlockProps = {
  block: SpacingBlockType,
  inline: boolean,
};
export default function SpacingBlock({ block, inline }: SpacingBlockProps) {
  if (inline) {
    return null;
  }
  return <div style={{ height: `${block.lines}em` }} />;
}
